<template>
  <v-list flat>
    <v-list-item-group
      color="primary"
    >
      <v-list-item
        class="px-0"
        v-for="(lote, i) in lotes"
        :key="i"
      >
        <v-list-item-content
          @click="() => handleLoteClick(lote)"
        >
          <Lote
            :isStatusCliente="isStatusCliente"
            :isUsuarioTradimus="isUsuarioTradimus"
            :lote="lote"
            :isSelected="selectedLotesIds.includes(lote.id)"
            :canDoActions="canDoActions"
            @change:checkbox="() => handleChage(lote)"
          />
        </v-list-item-content>
      </v-list-item>
    </v-list-item-group>
  </v-list>
</template>

<script>
import Lote from './Lote.vue'

export default {
components: {
  Lote
},
props: {
  lotes: Array,
  selectedLotes: Array,
  isStatusCliente: Boolean,
  canDoActions: Boolean,
  isUsuarioTradimus: Boolean
},
methods: {
  handleChage (lote) {
    const isSelected = this.selectedLotesIds.includes(lote.id)

    if (isSelected) {
      this.$emit('deselectLote', lote)
    } else {
      this.$emit('selectLote', lote)
    }
  },
  handleLoteClick (lote) {
    if (window?.getSelection()?.toString()) {
      return;
    }

    const params = {
      pagamentoId: this.$route.params.pagamentoId,
      loteId: lote.id
    }
    this.$router.push({ name: 'pagamentoLote', params })
  }
},
computed: {
  selectedLotesIds () {
    return this.selectedLotes.map(lote => lote.id)
  }
}
}
</script>

<style scoped>
.v-list-item__content{
  padding: 8px 0;
}
</style>
